import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import RunningKPI from './RunningKPI';

const KpiDashboard = () => {
  return (
    <>
      <PageHeader
        title="KPI Dashboard"
        description={`Manage and view all available Kpi from this page.`}
        className="mb-3"
      ></PageHeader>
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <RunningKPI />
        </Col>
      </Row>
    </>
  );
};

export default KpiDashboard;
